import React from "react";
import { toast } from "react-toastify";

import AuthService from "../../../services/auth.service";

export const SubscriptionActiveTab = ({ subscription, subscriptionIndex }) => {
  function redirectToNewWeight() {
    window.location.replace("/weighing");
  }

  function showUserMeal(subscription, period, periodIndex) {
    if (subscription.processing && period.processing) {
      return false;
    }
    if (period.is_expired && period.need_user_form) {
      toast.warn(
        "به دلیل وارد نکردن اطلاعات در زمان مقرر، رژیم این دوره صادر نشد.",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
      return false;
    }
    if (!period.enabled && !period.need_user_form && !period.is_expired) {
      toast.warn(
        "رژیم دوره جدید پس از اتمام دوره جاری با وزن کشی جدید و اطلاعات جدید شما آماده می شود",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        }
      );
    }
    window.location.href = `/subscriptions/${subscription.id}/periods/${periodIndex}`;
  }
  function showNextPeriodMessage() {
    toast.warn(
      "رژیم دوره جدید پس از اتمام دوره جاری با وزن کشی جدید و اطلاعات جدید شما آماده می شود",
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      }
    );
  }

  return (
    <div className="subscription" key={subscriptionIndex}>
      <div className="subscription-header">
        <div
          className="subscription-title"
          style={{
            backgroundColor: subscription.periods.length
              ? "#25AF9E"
              : "rgb(208,132,20)",
          }}
        >
          {subscription?.regime_title}
        </div>
      </div>

      <div className="subscription-periods">
        {subscription.periods.length ? (
          subscription.periods.map((period, periodIndex) => {
            let processing = subscription.processing ? (
              <div className="text-loading">{subscription.status_label}</div>
            ) : (
              ""
            );
            return (
              <div className="period" key={periodIndex}>
                <div className="title">{period.title}</div>
                <div></div>
                <div className="period-content-div flex-col flex-wrap">
                  <div className="content ">{period.content}</div>
                  <div className="period-content">
                    <button
                      className={` btn-action p-0 ${
                        !period.enabled || subscription.processing
                          ? "btn-disabled"
                          : ""
                      }`}
                    >
                      {processing && period?.processing ? (
                        <div className="text-loading">
                          {subscription.status_label}
                        </div>
                      ) : period.need_user_form && !period.is_expired ? (
                        <span
                          className={
                            period.need_user_form && !period.is_next_period
                              ? "btn-link"
                              : "btn-grey"
                          }
                          onClick={
                            period.need_user_form && !period.is_next_period
                              ? redirectToNewWeight
                              : showNextPeriodMessage
                          }
                        >
                          دریافت برنامه جدید
                        </span>
                      ) : !period.is_next_period &&
                        !period.need_user_form &&
                        period.status === 2 ? (
                        <span>{subscription.status_label}</span>
                      ) : (
                        <span
                          className={`${
                            period.is_expired ? "period-content" : "btn-link"
                          }`}
                          onClick={(e) =>
                            showUserMeal(subscription, period, periodIndex)
                          }
                        >
                          مشاهده رژیم
                        </span>
                      )}
                    </button>
                  </div>
                </div>

                {period.is_expired || period.expiration_text ? (
                  <div className="expired-div">
                    {period.expiration_text && (
                      <span className="expired-text">
                        {period.expiration_text}
                      </span>
                    )}
                    {period.is_expired && period.need_user_form ? (
                      <span className="delayed-span">
                        <span className="delayed-text ">
                          تاخیر در وارد کردن اطلاعات
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          })
        ) : (
          <div className="period">
            <div className="period-content-div">
              <div className="title">{subscription?.regime_title}</div>
              <div className="period-content">
                <button className="btn-action">
                  <span
                    onClick={
                      AuthService && !AuthService.getSubscription()
                        ? redirectToNewWeight
                        : showNextPeriodMessage
                    }
                    className={`${
                      !AuthService.getSubscription() ? "btn-link" : "btn-grey"
                    }`}
                  >
                    {AuthService && !AuthService.getSubscription()
                      ? "دریافت برنامه جدید"
                      : "مشاهده رژیم"}
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
